import { useMutation } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';


export interface AddSegmentValuePayload{
    projectId:string;
   segmentId:string;
   contextId:string;
   contextValues:string[];
}


const addSegmentValue = async (payload:AddSegmentValuePayload) => {
  try {
    const url = paths.addSegmentValue();
    const response = await axiosInstance.post(url, {input: payload});
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
  
};

export const useAddSegmentValue = () => {
  return useMutation(addSegmentValue);
}; 